import { render, staticRenderFns } from "./ConnectionBanner.vue?vue&type=template&id=0987370e&scoped=true"
import script from "./ConnectionBanner.vue?vue&type=script&lang=js"
export * from "./ConnectionBanner.vue?vue&type=script&lang=js"
import style0 from "./ConnectionBanner.vue?vue&type=style&index=0&id=0987370e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0987370e",
  null
  
)

export default component.exports